// extracted by mini-css-extract-plugin
export default {"questionMover":"questionMover-H0jbA","arrow":"arrow-s5lHj"};